// client/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import ModularGame from './pages/ModularGame';
import { GameProvider } from './context/GameContext';
import './App.css';

function App() {
  return (
    <GameProvider>
      <Router>
        <div className="App">
          <header className="App-header">
            <h1>Gibberers</h1>
          </header>
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/game" element={<ModularGame />} />
              <Route path="/game/:gameId" element={<ModularGame />} />
              {/* Redirect old modular-game routes to new game routes */}
              <Route path="/modular-game" element={<Navigate to="/game" replace />} />
              <Route path="/modular-game/:gameId" element={
                ({ params }) => <Navigate to={`/game/${params.gameId}`} replace />
              } />
            </Routes>
          </main>
        </div>
      </Router>
    </GameProvider>
  );
}

export default App;